import jquery from 'jquery'

window.$ = window.jQuery = jquery
window._wq = window._wq || []

// Wistia config
_wq.push({
    id: '_all',
    options: {
        playerColor: '171719',
        wmode: 'transparent',
        autoPlay: true,
        silentAutoPlay: false,
        resumable: false,
        endVideoBehavior: 'reset',
        controlsVisibleOnLoad: false,
        copyLinkAndThumbnailEnabled: false,
        fullscreenButton: true,
        fullscreenOnRotateToLandscape: true,
        playbar: true,
        playButton: true,
        smallPlayButton: true,
        volumeControl: true,
        plugin: {
            'captions-v1': {
                subtitlesScale: 1.1
            },
            'postRoll-v1': {
                rewatch: true,
                raw: `<a href="${window.button_url}" class="plc__video-cta" onclick="window.handleTags(event, this, 'wistia_cta')">${window.button_text}</a>`
            }
        }
    },
    onReady: (video) => {
        // Create additional fullscreen button for mobile devices
        if(isMobile() && !isIPad()) {
            Wistia.defineControl(FullscreenButton)
        }

        let updated_progress = false

        // 50% Video Watched Handler @Peter
        video.bind('secondchange', (seconds) => {
            const percentWatched = seconds / video.duration()
            
            if (percentWatched > .5 && updated_progress === false) {
                updated_progress = true
                trackIpsKeyEvent('watched_50_percent')

                if(window.contact_id){
                    $.post(window.action_endpoint, {
                        "uid": window.contact_id, 
                        "action": "watched"
                    });
                }
            }
        })
    }
})

// Custom fullscreen button
class FullscreenButton {
    mount (rootElem) {
        this.button = document.createElement('div')
        this.button.setAttribute('class', 'w-fullscreen')
        this.button.innerHTML = '<img src="https://services.iphonephotographyschool.com/modules/forms/media/plc/fullscreen.svg" alt="fs">'
        this.button.style.opacity = 0
        this.button.style.transition = 'opacity 200ms ease'
        rootElem.addEventListener('click', this.onClick)
        rootElem.appendChild(this.button)
    }
    onClick () {
        // Delegate click action to Wistia default fullscreen button
        // in order for this feature to work on mobile browsers
        document.querySelector('[data-handle="fullscreenButton"] button').click()
    }
    onControlPropsUpdated () {
        this.button.style.opacity = this.props.controlsAreVisible ? 1 : 0
    }
}

FullscreenButton.handle = 'fullscreenVideo'
FullscreenButton.type = 'above-control-bar'
FullscreenButton.sortValue = 50

// Check if device is mobile
function isMobile () {
    if(/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)
    || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1)
    && !window.MSStream) {
        return true
    }
    return false
}

// Check if device is iPad
function isIPad () {
    if(/iPad/i.test(navigator.userAgent)
    || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1) && !window.MSStream) {
        return true
    }
}

// iPad 100% height without scroll hack
function getAppHeight () {
    const doc = document.documentElement
    doc.style.setProperty('--app-height', `${window.innerHeight}px`)
}

function iPadHeightFix () {
    window.addEventListener('resize', getAppHeight)
    getAppHeight()
}
iPadHeightFix()

// Handle tags adding
window.handleTags = (e, self, buttonLocation) => {
    e.preventDefault()
    trackIpsKeyEvent('clicked_' + buttonLocation)

    const url = self.getAttribute('href');
    
    if (!window.contact_id){
        window.location.href = url
    } else {
        $.post(window.action_endpoint, {
            "uid": window.contact_id, 
            "action": "clicked"
        }).done(function() {
            window.location.href = url
        })
    }
}

function trackIpsKeyEvent(event){
    let payload = Object.assign({
        domain: window.domain,
        slug: window.slug,
        event: event, 
        uid: window.contact_id,
        email: window.contact_email,
    }, window.utms)

    if(window.env === 'production'){
        var url = 'https://services.iphonephotographyschool.com/events/sales-page/'
    }

    if(window.env === 'staging'){
        var url = 'https://staging-services.iphonephotographyschool.com/events/sales-page/'
    }

    if(window.env === 'production' || window.env === 'staging'){
        var xhr = new XMLHttpRequest();
        xhr.open('GET', url + 'plc.ipslog?' + generateQueryString(payload))
        xhr.send();
    } else {
        console.table(payload)
    }
}

function generateQueryString(params){
    return Object.keys(params).map((key) => {
        return encodeURIComponent(key) + '=' + encodeURIComponent(params[key])
    }).join('&');
}

document.addEventListener('DOMContentLoaded', function() {
    trackIpsKeyEvent('page_loaded')
})